import { StateCreator } from 'zustand';
import { GameStore } from '@/features/games/shared/store/game-store';
import { PurchaseHistorySlice } from '@/features/games/shared/types/purchase-history.types';

import {
  bustPurchaseHistoryCache,
  fetchPurchaseHistoryCached,
} from '@/features/games/internal/helpers/browser-clients/fetch-purchase-history';

export const createPurchaseHistorySlice: StateCreator<GameStore, [], [], PurchaseHistorySlice> = (
  set,
) => ({
  purchaseHistory: null,
  historyLoaded: false,
  bustPurchaseHistoryCache: () => {
    bustPurchaseHistoryCache();
    set({ purchaseHistory: null, historyLoaded: false });
  },
  fetchPurchaseHistory: async () => {
    set({ historyLoaded: false });
    try {
      const purchaseHistory = await fetchPurchaseHistoryCached();
      set({
        purchaseHistory,
        historyLoaded: true,
      });
    } catch (err) {
      console.error('Failed to fetch purchase history:', err);
      set({
        purchaseHistory: { grantKeys: [], rentals: [] },
        historyLoaded: true,
      });
    }
  },
});
